import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsOlx() {
  return <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.OLX} />;
}
